import React from 'react';
interface HeroSectionProps {
  searchQuery?: string;
  onSearchChange?: (query: string) => void;
}
export function HeroSection(_props: HeroSectionProps) {
  return <section className="w-full overflow-hidden bg-[#0B0B0B]" aria-label="NOIZA" data-id="element-2465" data-mp="34rdvjywuehj2">
      <img src="https://cdn.magicpatterns.com/uploads/3ezoNyb5A5ixTcRiwUDQDN/Banner_web_horizontal_de_Halloween.png" alt="NOIZA — Halloween Sabroso en la Zona de los Santos. Café, comida, montañas y gente linda. Pedí en tus restaurantes favoritos en noizacr.com" className="block h-auto w-full max-h-[78vh] object-cover object-center" data-id="element-2466" data-mp="2qtp7ki7hau9s" />
    </section>;
}